import ProgressBar from '../progressBar/progressBar'

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode
  className?: string
  comingSoon?: boolean
  loadingState?: boolean
  progressStyle?: React.CSSProperties | undefined
  index?: number
}

const Card = ({
  children,
  className,
  comingSoon,
  loadingState,
  progressStyle,
  index = 0,
  ...rest
}: CardProps) => {
  return (
    <div
      className={`
        relative flex flex-col
        ${index % 2 === 0 ? 'bg-primary' : 'bg-table-raw'}
        md:rounded-radius-md text-primary-foreground
        md:border border-border
        md:shadow-[0_4px_4px_rgba(129,129,129,0.25)]
        ${className}
      `}
      data-testid='card'
      {...rest}
    >
      {/* flex-1 instead of h-full — works regardless of parent height */}
      <div
        className={`${comingSoon ? 'blur-[2px] cursor-not-allowed' : ''} relative flex flex-col flex-1 min-h-0`}
      >
        {children}
      </div>
      {comingSoon && (
        <div className='absolute inset-0 flex items-center justify-center z-10 ~text-sm/3xl text-info top-[25px] font-semibold'>
          Insufficient Data
        </div>
      )}
      {loadingState && progressStyle && (
        <ProgressBar progress={progressStyle} />
      )}
    </div>
  )
}

export default Card
